import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import { SPS_ID } from "../simple-prompt-studio/constants";

const useSimplePromptStudio = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleSpsNavigate = (page) => {
    const newSearchParams = new URLSearchParams(searchParams);
    const projectId = Cookies.get(SPS_ID);
    if (projectId) newSearchParams.set(SPS_ID, projectId);

    navigate(`/simple-prompt-studio/${page}?${newSearchParams.toString()}`);
  };

  return {
    handleSpsNavigate,
  };
};

export default useSimplePromptStudio;
